module.exports = __webpack_public_path__ + "img/CLS-P-250.b6cf0b61.svg";